import React from 'react';
import get from 'lodash';
import { connect } from 'react-redux';

import BaseModal from '../BaseModal';
import Button from '../Button';
import CloseIcon from '../../assets/images/close_gray.svg';
import { hideModal } from '../../actions/modals';

import {
  bankLinkDisclaimer,
} from '../../actions/bankLinks';

import './styles.css';
import BankInfo from '../SignUp/BankInfo';

class BankLinkDisclaimerModal extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      bankLinkDisclaimerStatus: 'DECLINED',
    };
    this.onClose = this.onClose.bind(this);
    this.onContinue = this.onContinue.bind(this);
  }

  onClose() {
    this.props.bankLinkDisclaimer('DECLINED');
    this.props.hideModal();
  }

  onContinue() {
    this.props.bankLinkDisclaimer('ACCEPTED');
    this.props.hideModal();
  }

  render() {
    const { bankLinkDisclaimerStatus, accountNumber } = this.state;
    const dialogStyle = {
    //   backgroundColor: 'black',
    };
    return (
      ((bankLinkDisclaimerStatus && bankLinkDisclaimerStatus !== 'ACCEPTED') ?
        <BaseModal onClose={this.onClose} dialogStyle={dialogStyle}>
          <div styleName="dialogContainer">
            <div styleName="dialogHeader">
              <button onClick={this.onClose} type="button" styleName="dialogHeaderCloseBtn">
                <img width="12" src={CloseIcon} alt="icon" />
              </button>
            </div>
            <div styleName="dialogTitle">
              Linking your bank account
            </div>
            <div styleName="dialogText">
                By entering your bank account information, you are authorizing My IPO to communicate your bank account information to Folio Investments, Inc. (“Folio”), My IPO’s chosen custodian. You also authorize My IPO to make transfers between this bank account and your account that is held at Folio.
            </div>
            <div styleName="dialogActions">
              <Button
                // className="dialogActionsContinueBtn"
                style={{
                  width: 320,
                  marginLeft: '46px',
                  marginRight: '46px',
                  padding: '0',
                }}
                onClick={this.onContinue}
              >Continue
              </Button>
              <Button
                // className="dialogActionsCancelBtn"
                style={{
                  width: 320,
                  marginLeft: '46px',
                  marginRight: '46px',
                  padding: '0',
                  border: 'none',
                  boxShadow: 'none',
                  fontWeight: 'normal',
                }}
                onClick={this.onClose}
              >Cancel
              </Button>
            </div>
          </div>
        </BaseModal> : <BankInfo accountNumber={accountNumber} isSignUp={false} onNext={() => {}} bankLinkDisclaimerStatus={bankLinkDisclaimerStatus} />)
    );
  }
}

const mapStateToProps = state => ({
  accountNumber: state.currentAccount,
  bankLinkDisclaimerStatus: get(state, 'bankLinkInfo.bankLinkDisclaimerStatus'),
});

const mapDispatchToProps = dispatch => ({
  bankLinkDisclaimer: bankLinkDisclaimerStatus => (dispatch(bankLinkDisclaimer(bankLinkDisclaimerStatus))),
  hideModal: () => (dispatch(hideModal())),
});

export default connect(mapStateToProps, mapDispatchToProps)(BankLinkDisclaimerModal);



// WEBPACK FOOTER //
// ./src/components/BankLink/BankLinkDisclaimerModal.js